module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Modal":{"close":{"ariaLabel":"Zavřít"}}},"en":{"Modal":{"close":{"ariaLabel":"Close"}}}}')
  delete Component.options._Ctor
}
